import {useRecoilValue} from 'recoil';

import {userState} from '_/state/user';
import {GlobalPermissions, GlobalPermissionsType} from '_/utilities/types';

type ReturnType = {
  checkPermission: (
    requestedPermission: GlobalPermissionsType | undefined
  ) => boolean;
  checkOnePermission: (
    requestedPermissions:
      | GlobalPermissionsType
      | GlobalPermissionsType[]
      | undefined
  ) => boolean;
  hasCancelInvoicePermission: boolean;
  hasManageCasusDeletionPermission: boolean;
  hasManageCasusProtectionPermission: boolean;
};

export const usePermissionChecker = (): ReturnType => {
  const {permissions: userPermissions} = useRecoilValue(userState);

  const checkPermission = (
    requestedPermission: GlobalPermissionsType | undefined
  ) =>
    requestedPermission === undefined ||
    userPermissions.includes(requestedPermission);

  const checkOnePermission = (
    requestedPermissions:
      | GlobalPermissionsType
      | GlobalPermissionsType[]
      | undefined
  ) => {
    if (requestedPermissions === undefined) {
      return true;
    }
    if (Array.isArray(requestedPermissions)) {
      return requestedPermissions.some((neededPermission) =>
        userPermissions.includes(neededPermission)
      );
    }
    return userPermissions.includes(requestedPermissions);
  };

  return {
    checkPermission,
    checkOnePermission,
    hasCancelInvoicePermission: checkPermission(
      GlobalPermissions.Invoicing.CancelInvoice
    ),
    hasManageCasusDeletionPermission: checkPermission(
      GlobalPermissions.Casus.ManageCasusDeletion
    ),
    hasManageCasusProtectionPermission: checkPermission(
      GlobalPermissions.Casus.ManageCasusProtection
    ),
  };
};
